import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import media from 'src/styles/Media.styled';
import styled from 'styled-components';
export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 3;
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '20px'};
    width: 5%;
    @media all and (width: 1366px) and (height: 1024px) and (orientation: landscape) {
        padding-right: 20px;
    }
    ${media.mediumDevice`
       margin-right:0px;
    `}

    ${media.mobileDevice`
        order: 2;
        margin-right: 0;
        width: 0%;
    `}
`;
export const CloseIcon = styled(Icon)``;

export const HeaderContainer = styled.div`
    display: inherit;
    margin-top: 5px;
    justify-content: space-between;
    position: relative;
`;

export const HeaderDetails = styled.div`
    display: inherit;
    justify-content: space-between;
    align-items: baseline;
    width: 80%;
    ${media.mobileDevice`
        display: block ;
        width: 255px;
    `};
`;

export const HeaderSpan = styled.div`
    font-size: 18px;
    color: #130e4a;
`;

export const FavoriteIconMobileContainer = styled.div`
    display: none;
    ${media.mobileDevice`
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 2px #00000029;
        border: 1px solid #ebebeb;
        border-radius: 6px;
        opacity: 1;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${({ marginRight }) => marginRight};
    `};
`;
export const FavouriteIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
`;

export const AccountHeaderFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '18px' : '18px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#130E4A' : isDemi && '#130E4A'};
    margin: 0px;
    width: ${(props) => (props.width ? props.width : '')};
    ${media.mediumDevice`
        width:${(props) => (props.mediumWidth ? props.mediumWidth : '')};
    `}
    ${media.smalDevice`
        width:${(props) => (props.ipadWidth ? props.ipadWidth : '')};
    `}
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '18px' : '18px')};
        padding-right: 10px;
        width:${(props) => (props.mbWidth ? props.mbWidth : '')};
    `}
`;

export const AccountSubHeaderFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '18px' : '13px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#130E4A'};
    margin: 2px;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '18px' : '13px')};
    `}
`;

export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    position: absolute;
    right: 100px;
    top: -3px;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
    @media all and (width: 1366px) and (height: 1024px) and (orientation: landscape) {
        right: 100px;
    }
    ${media.mobileDevice`
     right: 50px;
    `};
`;
export const BackToPhysician = styled.div`
    color: blue;
`;
export const BackButtonIcon = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    margin-left: -3px !important;
    ${media.mobileDevice`
        margin:1;
        margin-left:-6px
    `};
`;
export const BackButtonContainer = styled.div`
    display: inline-flex;
    margin-left: -6px !important;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 10px')};
    ${media.mobileDevice`
    `}
`;

export const BackText = styled.span`
    color: #1010eb;
    font-family: AvenirNextWorld Regular;
    font-size: 16px;

    ${media.mobileDevice`
    // justify-content: center;
    // display: flex;
   
    `}
`;
